import React from 'react';
import { uniq, camelCase } from 'lodash';
import { useTranslate } from '@hooks';
import { ProductApiNames } from '@constants';
import { Input } from '@dotone/react-ui-core';

const ProductApiNameSelect = ({ name, ...otherProps }) => {
  const { t } = useTranslate('clientApi', 'productApi');
  const { watch } = otherProps.formProps;
  const value = watch(name);

  let allowedProductApiNames = ProductApiNames;
  if (value) {
    allowedProductApiNames = uniq([value, ...allowedProductApiNames]);
  }

  const options = Object.values(allowedProductApiNames).map((productName) => ({
    value: productName,
    label: ProductApiNames.includes(productName) ? t(camelCase(productName)) : productName,
  }));

  return <Input type="select" name={name} options={options} {...otherProps} />;
};

export default ProductApiNameSelect;
